import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RouterProps } from 'react-router';
import AddToMerchantsView from './AddToMerchantsView';

import {
  selectAccounts,
  selectInstantCredit,
  Wallet,
} from 'state/instantCredit';
import useIdiSdk from 'hooks/useIdiSdk';

type PropTypes = RouterProps;

const AddToMerchants: React.FC<PropTypes> = () => {
  const { wallets } = useSelector(selectInstantCredit);
  const { pushProvision, inProgress } = useIdiSdk();
  const currentAccount = useSelector(selectInstantCredit);
  const accounts = useSelector(selectAccounts);
  const onChoice = useCallback(
    (wallet: Wallet) => {
      // sdk must already be initialized
      pushProvision(wallet, currentAccount, accounts);
    },
    [pushProvision, currentAccount, accounts],
  );

  return (
    <AddToMerchantsView
      inProgress={inProgress}
      onChoice={onChoice}
      wallets={(wallets && wallets.eligibleOnFileWallets) || []}
    />
  );
};

export default AddToMerchants;
